import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Location, useParams, useSearchParams } from 'react-router-dom'

import { getEmailGroup } from '@disco/state-management/selectors/emailGroups'

import type { RecipientList } from 'types/list'

import type { RootState } from 'store/configureStore'

import ContactsList from '../list'

type StateProps = {
  list: RecipientList | null | undefined
  appendingContacts: boolean
}
type OwnProps = {
  params: {
    listId: string
  }
  location: Location
  children: React.ReactNode
  searchParams: URLSearchParams
}

const mapStateToProps = (state: RootState, props: OwnProps): StateProps => {
  let listId
  let list = null
  let appendingContacts = false

  if (props.params.listId) {
    listId = parseInt(props.params.listId)
  } else if (props.searchParams.get('append')) {
    listId = parseInt(props.searchParams.get('append'), 10)
    appendingContacts = true
  }

  if (listId) {
    list = getEmailGroup(state, {
      listId: listId,
    })
  }

  return {
    list,
    appendingContacts,
  }
}

class ContactsMailingListRecipients extends React.Component<
  StateProps & OwnProps
> {
  render() {
    return (
      <React.Fragment>
        <ContactsList
          key={`${
            this.props.list ? this.props.list.id : '-'
          }-${this.props.appendingContacts.toString()}`}
          list={this.props.list}
          appendingContacts={this.props.appendingContacts}
        />
        {this.props.children}
      </React.Fragment>
    )
  }
}

const ConnectedContactsMailingListRecipients = connect(
  mapStateToProps,
  null,
)(ContactsMailingListRecipients)

// Wrapper component to provide router params to the connected component
const ContactsMailingListRecipientsWithRouter = (props: any) => {
  const params = useParams<{ listId: string }>()
  const [searchParams] = useSearchParams()
  return (
    <ConnectedContactsMailingListRecipients
      {...props}
      params={params}
      searchParams={searchParams}
    />
  )
}

export default ContactsMailingListRecipientsWithRouter
